<template>
  <div ref="wrapper" class="cards-block w-full relative p-2 md:container mx-auto mb-2">
    <div class="text-left md:text-center pt-2">
      <h2 v-if="navItemData.introText" class="text-xl font-heading mb-2" v-html="navItemData.introText" />
      <ul
        v-if="hasSecondaryLinks"
        class="w-full md:flex flex-wrap md:justify-center gap-3 list-none mx-0 px-0 mb-4"
        role="menu"
      >
        <li v-for="(link, index) of visibleSecondaryLinks" :key="index" class="mx-0 px-0" role="none">
          <a
            class="underline py-2 text-xs nav__menu-item hover:no-underline"
            :href="composeLink(link.url)"
            :target="setTarget(link.target)"
            :qaid="link.uid"
            role="menuitem"
            @keydown.prevent.down="focusNextElement"
            @keydown.prevent.up="
              (e) => {
                isCompactView ? focusPreviousElement(e) : focusParentTier();
              }
            "
            @keydown.prevent.right="focusNextElement"
            @keydown.prevent.left="
              (e) => {
                !isCompactView ? focusPreviousElement(e) : focusParentTier();
              }
            "
          >
            {{ link.linkName }}
          </a>
        </li>
      </ul>
    </div>
    <div class="card-section mb-5">
      <ul class="grid gap-4 md:grid-cols-2 lg:grid-cols-3 auto-rows-fr list-none" role="menu">
        <template v-if="isDetailedBikeCard">
          <nav-bike-card
            v-for="item of visibleBikeCards"
            :key="item.uid"
            :nav-item-data="item"
            :down-function="focusNextElement"
            :up-function="
              (e) => {
                isCompactView ? focusPreviousElement(e) : focusParentTier();
              }
            "
            :right-function="focusNextElement"
            :left-function="
              (e) => {
                !isCompactView ? focusPreviousElement(e) : focusParentTier();
              }
            "
          />
        </template>
        <template v-else>
          <nav-bike-family-card
            v-for="item of visibleBikeCards"
            :key="item.id"
            :nav-item-data="item"
            :down-function="focusNextElement"
            :up-function="
              (e) => {
                isCompactView ? focusPreviousElement(e) : focusParentTier();
              }
            "
            :right-function="focusNextElement"
            :left-function="
              (e) => {
                !isCompactView ? focusPreviousElement(e) : focusParentTier();
              }
            "
          />
        </template>
        <li v-for="item of visibleEditorialCards" :key="item.id" role="none">
          <NavCard
            :card="item"
            :down-function="focusNextElement"
            :up-function="
              (e) => {
                isCompactView ? focusPreviousElement(e) : focusParentTier();
              }
            "
            :right-function="focusNextElement"
            :left-function="
              (e) => {
                !isCompactView ? focusPreviousElement(e) : focusParentTier();
              }
            "
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import NavBikeFamilyCard from '@/navigation/NavBikeFamilyCard.vue';
import NavBikeCard from '@/navigation/NavBikeCard.vue';
import {ProductCardType} from '@/navigation/utils/nav-constants.js';
import NavCard from '@/navigation/components/NavCard.vue';
import {mapState} from 'vuex';
import links from '@/navigation/mixins/links.js';
export default {
  name: 'NavCardsLayout',
  components: {
    NavBikeFamilyCard,
    NavBikeCard,
    NavCard,
  },
  mixins: [links],
  inject: ['focusParentTier', 'focusNextMenuItem', 'focusPreviousMenuItem'],

  props: {
    navItemData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState('global', ['isCompactView']),
    navElements() {
      let els = [];
      this.$refs.wrapper.querySelectorAll('.nav__menu-item').forEach((el) => {
        els.push(el);
      });
      return els;
    },
    hasSecondaryLinks() {
      return this.navItemData.secondaryLinks.length > 0;
    },
    visibleSecondaryLinks() {
      return (
        this.navItemData?.secondaryLinks?.filter(
          (link) => link?.hasVisibleProducts !== false && link.visible !== false
        ) || []
      );
    },
    visibleBikeCards() {
      return (
        this.navItemData?.links?.filter((item) => item?.hasVisibleProducts !== false && item?.visible !== false) || []
      );
    },
    visibleEditorialCards() {
      return (
        this.navItemData?.categoryCardEditorialComponentData?.filter(
          (item) => item.ctaLinks?.[0]?.hasVisibleProducts !== false && item.ctaLinks?.[0]?.visible !== false
        ) || []
      );
    },
    isDetailedBikeCard() {
      return this.navItemData?.productCardType === ProductCardType.BIKE;
    },
  },
  methods: {
    focusNextElement(e) {
      const elIndex = this.navElements.indexOf(e.target);
      e.target.tabIndex = -1;
      const targetIndex = elIndex < this.navElements.length - 1 ? elIndex + 1 : 0;
      this.navElements[targetIndex].tabIndex = 0;
      this.navElements[targetIndex].focus();
    },
    focusPreviousElement(e) {
      const elIndex = this.navElements.indexOf(e.target);
      e.target.tabIndex = -1;
      const targetIndex = elIndex > 0 ? elIndex - 1 : this.navElements.length - 1;
      this.navElements[targetIndex].tabIndex = 0;
      this.navElements[targetIndex].focus();
    },
  },
};
</script>
